import validate from 'validate.js';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const validateParkingForm = ({
  cancellation_policy = ''
}) => {
  return {
    cancellation_policy: validate.single(cancellation_policy,
      {
        presence: {
          allowEmpty: false,
          message: <FormattedMessage id="hosting.validate_cancellation_policy_form.select_option_message" defaultMessage="Please select an option" />
        }
      })
  };
};

export default validateParkingForm;
